
export { localStorageUtils } from "/codebuild/output/src2315228166/src/packages/utils/src/storage/index.ts"